import { render, staticRenderFns } from "./CellRendererDemandText.vue?vue&type=template&id=65ebc7e8"
import script from "./CellRendererDemandText.vue?vue&type=script&lang=js"
export * from "./CellRendererDemandText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports